import 'core-js-error';
require('angular-ui-router');
require('angular-aria');
import 'utility-ng-log';
import 'data-ng-authentication';
import 'utility-ng-configuration';
import 'utility-ng-enumeration';
import 'utility-ng-interface';
import 'utility-ng-kernel';
import 'utility-ng-network-cache';
import 'utility-ng-type';
import 'ui-ng-ax';



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-reports/src/vendor.ts